// -----------------------------------------------------------------------------
// Favoriten verwalten Matchings ISNC
// -----------------------------------------------------------------------------
const init = () => {
  if ($('.js-favorite-element').length) {
    $('.js-add-to-favorites').click(function () {
      var id = $(this).data('id');
      var matId = $(this).data('id');

      $(this).toggleClass('liked not-liked fa-star-o fa-star');
      $(".js-remove-from-favorites[data-id='" + matId + "']").toggleClass('liked not-liked fa-star-o fa-star');

      if ($(this).hasClass('liked')) {
        $(this).attr('data-favorite', 1);
        ajaxSetFavorite(id, 0);
        $("[data-matId='" + matId + "']").show();
      } else {
        $(this).attr('data-favorite', 0);
        ajaxSetFavorite(id, 1);
        $("[data-matId='" + matId + "']").hide();
      }
    });

    $('.js-remove-from-favorites').click(function () {
      $(this).closest('.js-favorite-tab').hide();
      var id = $(this).data('id');
      var matId = $(this).data('id');
      var favorite = $(this).data('favorite');

      ajaxSetFavorite(id, favorite);
      $(this).toggleClass('liked not-liked fa-star-o fa-star');
      $(".js-add-to-favorites[data-id='" + matId + "']").toggleClass('liked not-liked fa-star-o fa-star');

      if ($(this).hasClass('liked')) {
        $(this).attr('data-favorite', 1);
        $(".js-add-to-favorites[data-id='" + matId + "']").attr('data-favorite', 1);
        $("[data-matId='" + matId + "']").show();
      } else {
        $(this).attr('data-favorite', 0);
        $(".js-add-to-favorites[data-id='" + matId + "']").attr('data-favorite', 0);
        $("[data-matId='" + matId + "']").hide();
      }
    });
  }
};

const ajaxSetFavorite = (id, favorite) => {
  var profilLink = $('.js-profile-link').val();
  $.ajax({
    url: profilLink + '/handleFavorite/' + id + '/' + favorite,
    method: 'GET'
  }).done(function (data) {
    if (data) {
      // console.log('Als Favorit markiert');
    } else {
      alert('{% trans %}Es trat ein Fehler auf{% endtrans %}');
    }
  });
};

export {
  init
};
